import React, { useState, useRef, useEffect, Fragment } from "react";
import { Redirect } from "react-router-dom";
import Header from "./Header";
import LangSwitcher from "./LangSwitcher";
import Player from "@vimeo/player";
import installationPic from "../one-in-three-installation.jpg";

import { landing as str } from "$strings";

const DownArrow = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      viewBox="237.5 97.5 125.5 165.5"
    >
      <defs>
        <path d="M360 200L300 260L240 200" id="i1jJBvEylI"></path>
        <path d="M300 100L300 260" id="bA7zk3x54"></path>
      </defs>
      <g>
        <g>
          <g>
            <use
              xlinkHref="#i1jJBvEylI"
              opacity="1"
              fillOpacity="0"
              stroke="#999999"
              strokeWidth="5"
              strokeOpacity="1"
            />
          </g>
        </g>
        <g>
          <g>
            <use
              xlinkHref="#bA7zk3x54"
              opacity="1"
              fillOpacity="0"
              stroke="#999999"
              strokeWidth="5"
              strokeOpacity="1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default () => {
  const [redirect, setRedirect] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const playbackButtonEl = useRef(null);
  const timelineSliderEl = useRef(null);

  useEffect(() => {
    // try {
    const player = new Player("one-in-three-video", {
      id: 380831653,
      autoplay: true,
      background: true,
      loop: true,
      muted: true
    });
    window.player = player;
    player.play();
    player.getDuration().then(duration => {
      const randStart = Math.round(Math.random() * duration);
      player.setCurrentTime(randStart);
    });
    // } catch (err) {
    //   setErrorMsg(err);
    // }
    // playbackButtonEl.current.addEventListener("click", async e => {
    //   const paused = await player.getPaused();
    //   if (paused) {
    //     player.play();
    //   } else {
    //     player.pause();
    //   }
    // });
    // player.getDuration().then(duration => {
    //   timelineSliderEl.current.setAttribute("max", duration);
    // });
    // timelineSliderEl.current.addEventListener("change", async e => {
    //   player.setCurrentTime(timelineSliderEl.current.value);
    // });
    // const timelineUpdater = setInterval(() => {
    //   player.getCurrentTime().then(t => {
    //     timelineSliderEl.current.value = t;
    //   });
    // }, 1000);
    // return () => clearInterval(timelineUpdater);
  }, []);

  const handleClick = () => {
    setRedirect(true);
    window.scrollTo(0, 0);
  };

  if (redirect) {
    console.log("redirect true");
    return <Redirect to="/upload" />;
  }

  if (errorMsg) {
    return <div>{errorMsg.message}</div>;
  }

  return (
    <Fragment>
      <div className="App">
        {/* <h1>{`${window.screen.width}x${window.screen.height}`}</h1> */}
        <div className="App-hero">
          <Header floating />
          <div id="one-in-three-video"></div>
          {/* <iframe
          title="embedded vimeo"
          src="https://player.vimeo.com/video/290143024?autoplay=1&loop=1"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe> */}
          {/* <button ref={playbackButtonEl}>play</button>
        <input
          ref={timelineSliderEl}
          type="range"
          id="place"
          name="volume"
          min="0"
          max="300"
        /> */}
        </div>
        <div className="App-body">
          <h2>{str.statistic}</h2>
        </div>
        <hr />
        <div className="App-body">
          <p>{str.description}</p>
          <p>{str.help_us}</p>
          <button onClick={handleClick}>{str.get_started}</button>
        </div>
        <hr className="last-line" />
        <div className="App-body about-section">
          <img src={installationPic} alt="Art installation" />
          <p>
            {str.call_to_action.split("\n\n").map((t, i) => (
              <Fragment key={i}>
                <span dangerouslySetInnerHTML={{ __html: t }} />
                <br />
                <br />
              </Fragment>
            ))}
            <br /> <br />
            <a onClick={handleClick}>{str.contribute_your_video} →</a>
          </p>
        </div>
        <div className="lang-switcher">
          <LangSwitcher />
        </div>
        <div className="down-arrow">
          <DownArrow />
        </div>
      </div>
    </Fragment>
  );
};
